import React from "react";
import classNames from "classnames/bind";
import WHEPPlayer from "../../../../components/WebRtc/WebRtc";
import styles from "./StreamCam.module.css";
import { PROTOCOL_TYPES } from "../../../../constant/index";

const cx = classNames.bind(styles);

/**
 * Video player component that renders HLS or WebRTC player
 */
const VideoPlayer = ({
    item,
    videoRef,
    binaryData,
    time,
    reload,
    setReload,
}) => {
    return (
        <>
            {/* Ưu tiên chạy WebRTC nếu camera có link item.rtc để kiểm tra */}
            {item.rtc ? (
                <WHEPPlayer
                    channelUrl={item.rtc}
                    reload={reload}
                    setReload={setReload}
                />
            ) : (
                <video
                    muted
                    ref={videoRef}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "fill",
                        display: "block",
                        aspectRatio: "16/9",
                    }}
                />
            )}

            {time && binaryData && (
                <img
                    src={binaryData}
                    alt={"image"}
                    style={{
                        width: "100%",
                        objectFit: "cover",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 70,
                    }}
                />
            )}
        </>
    );
};

export default VideoPlayer;
